<template lang="pug">
  v-navigation-drawer.custom-flex(
    temporary
    v-model="isActive"
    light
    absolute
    height='100vh'
  )
    v-list.pa-0
      v-list-tile
      
    v-list.side-menu.pt-0(dense)

      v-divider

      .top
        template(v-for="item in sidebarItems")
          //Links
          v-list-tile.py-1(
            v-if="item.link"
            :key="item.title"
            @click="$router.push(item.link)"
          )
            v-list-tile-content
              v-list-tile-title.body-2 {{ item.title }}
          // Help Center
          v-menu.offset-y(
            open-on-hover=true
            v-if="item.help"
          )
            template(v-slot:activator="{on}")
              v-list-tile.py-1
                v-list-tile-content
                  v-list-tile-title.body-2(v-on="on") {{item.title}}
            v-list 
              v-list-tile(v-for="item in helpItems"
              :key="item.title")  
                a.body-2.comfort-item(target="_blank" :href="item.url" style="color: #000;") {{item.title}}    
          // Notifications
          v-list-tile.py-1(
            v-else-if="item.click && !item.comfort"
            :key="item.title"
            @click="item.click"
          )
            v-list-tile-content
              v-list-tile-title.body-2 {{ item.title }} 


      .y-spacer

      .bottom
        p
          | Call us: {{ phoneNumber }}
          br
          | Version {{ appVersion }}

        p.signout(
          @click="$router.push('/logout')"
        )
          v-icon.signout-icon.mr-1 exit_to_app
          span.body-2 Signout
        p.caption &copy; {{ new Date().getFullYear()  }} OnCall Air Finance+. All rights reserved

</template>

<script>
  import envVars from '@/env_vars'
  export default {
    name: 'home-nav-drawer',
    data() {
      return {
        appVersion: (envVars.appVersion.indexOf('_') === 0)
          ? envVars.appVersion
          : envVars.appVersion.replace(/_/g, '.'),
        isActive: false,
        phoneNumber: '786-375-9482',
        sidebarItems: [
          {
            title: 'Home',
            icon: require('Assets/gray_box.png'),
            link: '/home'
          },
          {
            title: 'Notifications',
            click: this.openNotificationsDialog
          },
          {
            title: 'Help',
            help: true
          }
        ],
        comfortItems: [
          {
            title: "Install directly into HTML",
            action: this.openComfortButtonDialog
          },
          {
            title: "Install using Wix",
            action: this.openWixDialog
          }
        ],
        helpItems: [
          {
            title: 'Visit Our Help Center', 
            url: 'https://help.creditforcomfort.com/'
          },
          {
            title: 'Marketing Resources',
            url: 'https://www.creditforcomfort.com/marketing/'
          },
          {
            title: 'Homeowner FAQ',
            url: 'https://www.creditforcomfort.com/homeowner'
          },
          {
            title: 'Contractor FAQ',
            url: 'https://www.creditforcomfort.com/faq'
          },
        ]
      }
    },
    props: {
      drawer: {
        type: Boolean,
        default: false
      }
    },
    methods: {
      emitSwap () {
        this.$emit('swapDrawer')
      },
      openComfortButtonDialog() {
        this.$store.dispatch('setInstructions', 'html')
        this.$store.commit('openDialog', {
          component: 'comfort-button-dialog',
        })
      },
      openNotificationsDialog() {
        this.$store.commit('openDialog', {
          component: 'notifications-dialog',
        })
      },
      openWixDialog(){
        this.$store.dispatch('setInstructions', 'wix')
        this.$store.commit('openDialog', {
          component: 'comfort-button-dialog',
        })
      }
     
    },
    watch: {
      // if drawer changes to true, change isActive to true
      drawer () {
        if (this.drawer) {
          this.isActive = this.drawer
        }
      },
      // if isActive changes to false, change drawer to false
      isActive () {
        if (!this.isActive) {
          this.$emit('swapDrawer')
        }
      }
    }
  }
</script>

<style scoped lang="scss">
  .custom-flex {
    display: flex;
    flex-direction: column;
  }
  
  // .v-navigation-drawer::v-deep .v-navigation-drawer--close {
  //   display: none;
  // }

  .custom-flex::v-deep .v-navigation-drawer--close {
    background: red;
  }

  .y-spacer {
    height: 55%;
  }

  .side-menu {
    flex: 1 1 auto;
  }

  .signout {
    &:hover {
      cursor: pointer;
    }

    & .signout-icon {
      font-size: 1.3em;
      color: rgba(0, 0, 0, 0.87);
    }
  }

  .comfort-item {
    &:hover{
      cursor: pointer;
    }
  }

 
</style>
